import React from "react";
import { Link } from "react-router-dom";
import {
  Brain, Layers, Code2, Shield, Landmark, Building2, HeartPulse, ShoppingBag,
  Zap, RadioTower, Target, Sparkles, Users, Globe, ArrowRight, Factory, Network, Cloud, ChartNoAxesCombined, Leaf,
} from "lucide-react";

export const ICONS = {
  brain: Brain, layers: Layers, code: Code2, shield: Shield,
  landmark: Landmark, building: Building2, "heart-pulse": HeartPulse,
  "shopping-bag": ShoppingBag, zap: Zap, "radio-tower": RadioTower,
  target: Target, sparkles: Sparkles, users: Users, globe: Globe,
  factory: Factory, network: Network, cloud: Cloud, chart: ChartNoAxesCombined, leaf: Leaf,
};

export const Icon = ({ name, className = "h-6 w-6" }) => {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} />;
};

export const Eyebrow = ({ children }) => (
  <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#E5E7EB] bg-[#F3F4F6] px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-[#4B5563]">
    <span className="h-1.5 w-1.5 rounded-full gradient-bg" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, gradient }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="font-display text-4xl font-semibold tracking-tight text-[#0A0A0A] sm:text-5xl">
      {title} {gradient && <span className="gradient-text">{gradient}</span>}
    </h2>
    {subtitle && <p className="mt-5 text-base leading-relaxed text-[#4B5563] sm:text-lg">{subtitle}</p>}
  </div>
);

export const PrimaryLink = ({ to, children, testid }) => (
  <Link
    to={to}
    className="group inline-flex items-center gap-2 rounded-full gradient-bg px-7 py-3.5 text-sm font-semibold text-white shadow-[0_0_24px_rgba(207,55,79,0.4)] transition-transform hover:scale-[1.03]"
    data-testid={testid}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
  </Link>
);

export const GhostLink = ({ to, children, testid }) => (
  <Link
    to={to}
    className="group inline-flex items-center gap-2 rounded-full border border-[#E5E7EB] px-7 py-3.5 text-sm font-semibold text-[#0A0A0A] transition-colors hover:border-[#9CA3AF] hover:bg-[#F3F4F6]"
    data-testid={testid}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
  </Link>
);

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </section>
);
